import { render } from "./TeamTemplates.vue?vue&type=template&id=69e45c64"
import script from "./TeamTemplates.vue?vue&type=script&lang=js"
export * from "./TeamTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__